import { Buffer } from 'buffer';

function uint8ToBase64(bytes?: Uint8Array): string | undefined {
  if (!bytes) {
    return undefined
  }
  return btoa(String.fromCharCode(...Array.from(bytes)))
}

function base64ToUint8(base64?: string): Uint8Array | undefined {
  if (!base64) {
    return undefined
  }
  const base64WithoutPadding = base64.replace(/=+$/, '')
  return Uint8Array.from(atob(base64WithoutPadding), c => c.charCodeAt(0))
}

function u8ToHex(u8: Uint8Array): string {
  return Buffer.from(u8).toString('hex')
}
export { uint8ToBase64, base64ToUint8, u8ToHex }
